<template>
  <section class="text-center">
    <h1
      class="font-weight-light text-h5"
      v-text="`${heading}`"
    />
  </section>
</template>

<script>
  export default {
    name: 'VComponent',

    props: {
      heading: {
        type: String,
        default: '',
      },
    },
  }
</script>
